import { useEffect, useRef, useState } from 'react';

export const useMediaType = (): [isDesktop: boolean, isTablet: boolean, isMobile: boolean] => {
    const [isDesktop, setIsDesktop] = useState(false);
    const [isTablet, setIsTablet] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    const desktopMedia = useRef<MediaQueryList | null>(null);
    const tabletMedia = useRef<MediaQueryList | null>(null);
    const mobileMedia = useRef<MediaQueryList | null>(null);

    useEffect(() => {
        desktopMedia.current = window.matchMedia('(min-width: 1024px)');
        tabletMedia.current = window.matchMedia('(min-width: 768px) and (max-width: 1024px)');
        mobileMedia.current = window.matchMedia('(min-width: 320px) and (max-width: 767px)');

        setIsMobile(mobileMedia.current.matches);
        setIsTablet(tabletMedia.current.matches);
        setIsDesktop(desktopMedia.current.matches);

        const handleDesktopMedia = (e: MediaQueryListEvent) => void setIsDesktop(e.matches);
        const handleTabletMedia = (e: MediaQueryListEvent) => void setIsTablet(e.matches);
        const handleMobileMedia = (e: MediaQueryListEvent) => void setIsMobile(e.matches);

        desktopMedia.current.addEventListener('change', handleDesktopMedia);
        tabletMedia.current.addEventListener('change', handleTabletMedia);
        mobileMedia.current.addEventListener('change', handleMobileMedia);

        return () => {
            desktopMedia.current?.removeEventListener('change', handleDesktopMedia);
            tabletMedia.current?.removeEventListener('change', handleTabletMedia);
            mobileMedia.current?.removeEventListener('change', handleMobileMedia);
        };
    }, []);

    return [isDesktop, isTablet, isMobile];
};